export const carColumns = [
    {
        name: "Car No",
        selector: (row) => row["carNo"],
        sortable: true,
        // center: true,
        width: "150px"
    },
    {
        name: "Registration No",
        selector: (row) => row["registrationNo"],
        sortable: true,
        // center: true,
        width: "180px"
    },
    {
        name: "Car Type",
        selector: (row) => row["carTypeName"],
        sortable: true,
        // center: true,
        width: "120px"
    },
    {
        name: "Aggregator",
        selector: (row) => row["aggregatorCompanyName"],
        sortable: true,
        // center: true,
        width: "220px"
    },
    {
        name: "Service City",
        selector: (row) => row["serviceCityName"],
        sortable: true,
        // center: true,
        width: "150px"
    },
    {
        name: "Procurement Status",
        selector: (row) => row["procurementStatus"],
        sortable: true,
        // center: true,
        width: "150px"
    },
    {
        name: "Available",
        selector: (row) => row["isAvailable"],
        sortable: true,
        // center: true,
        // width: "100px"
    },
    {
        name: "Expiry Remarks",
        selector: (row) => row["expiryRemarks"],
        sortable: true,
        // center: true,
        width: "150px"
    },
    {
        name: "DELETED",
        selector: (row) => row["Deleted"],
        sortable: true,
        // center: true,
        omit:true,
    },
    {
        name: "",
        selector: (row) => row["action"],
        sortable: true,
        center: true,
        width: "50px",
        style: {
            justifyContent: "flex-end",
            marginLeft: "10px"
        },
    },
];

export const unavailableCarColumns = [
    {
        name: "Car No",
        selector: (row) => row["carNo"],
        sortable: true,
        // center: true,
        width: "150px"
    },
    {
        name: "Unavailable Date",
        selector: (row) => row["unavailableDate"],
        sortable: true,
        // center: true,
        width: "180px"
    },
    {
        name: "Created",
        selector: (row) => row["createdOn"],
        sortable: true,
        // center: true,
        width: "120px"
    },
    {
        name: "Blocked by",
        selector: (row) => row["createdByName"],
        sortable: true,
        // center: true,
        width: "220px"
    },
    {
        name: "Blocked Reason",
        selector: (row) => row["blockedReason"],
        sortable: true,
        // center: true,
        width: "200px"
    },
    {
        name: "Unblocked by",
        selector: (row) => row["availableByName"],
        sortable: true,
        // center: true,
        width: "220px"
    },
    {
        name: "Unblocked Reason",
        selector: (row) => row["unblockedReason"],
        sortable: true,
        // center: true,
        width: "200px"
    },
    {
        name: "Resolved",
        selector: (row) => row["isResolved"],
        sortable: true,
        // center: true,
        width: "100px"
    },
];

export const carFilterColumns = [
    {
        name: "IS AVAILABLE",
        value: "isAvailable",
        type: "boolean",
    },
    {
        name: "PROCUREMENT STATUS",
        value: "procurementStatus",
        type: "select",
    },
    {
        name: "CAR TYPE",
        value: "carTypeId",
        type: "select",
    },
    {
        name: "AGGREGATOR",
        value: "aggregatorId",
        type: "select",
    },
];